import React from "react";
import {View, StyleSheet} from "react-native";
import PtText from "../core/pt-text/pt-text";
import {getTranslation} from "../../helpers/getTranslation";
import {styleVars} from "../../app-style-vars";


export default function PtCopyright(props) {

  return (
    <View style={styles.copyrightContainer}>
      <PtText style={styles.footerCopyrightText}>{getTranslation('footer.copyright.text')}</PtText>
    </View>
  )
}

const styles = StyleSheet.create({
  copyrightContainer: {
    paddingHorizontal: styleVars.rem(1),
  },
  footerCopyrightText: {
    fontSize: styleVars.rem(.875),
    fontWeight: 'bold',
    color: '#000',
    lineHeight: styleVars.rem(1.25)
  },
});
